module.exports = __webpack_public_path__ + "img/Union.604ba138.png";